var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolution1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#33B140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9451 14.4733H13.9185L13.3171 17.26H14.4905V18.4627H13.0678L12.5691 20.7947H11.2931L11.7918 18.4627H10.1785L9.63581 21H8.35981L8.90248 18.4627H8.11048V17.26H9.16648L9.76781 14.4733H8.56515V13.2707H10.0318L10.5305 10.9387H11.8065L11.3078 13.2707H12.9065L13.4491 10.7333H14.7105L14.1678 13.2707H14.9451V14.4733ZM12.0558 17.26L12.6425 14.4733H11.0438L10.4425 17.26H12.0558ZM19.1027 21V14.1947H15.9054V13.124C17.812 13.0507 18.912 12.1267 19.2787 10.7333H20.584V21H19.1027Z",
    fill: "#E9FAE2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolution1);
export default __webpack_public_path__ + "static/media/solution1.7cc7264235411396a961d5005c4f0033.svg";
export { ForwardRef as ReactComponent };